// extracted by mini-css-extract-plugin
export default {"code":"CodeBlock_code__qQhhQ","button-container":"CodeBlock_button-container__57Ojy"};